import { useState } from "react";
import "../Component/Register.css"; // custom CSS file
import { API_BASE_URL } from "../config";

export default function Register() {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [phonno, setPhon] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (password !== confirmPassword) {
      alert("Passwords do not match!");
      return;
    }

    try{
      const response = await fetch(`${API_BASE_URL}/api/auth/register`,{
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          FullName: name,
          Email: email,
          PhoneNumber: phonno,
          Password: password
        }),
      });

      if(response.ok){
        alert("Registration successful");
        window.location.href = "/login";        
      }
      else{
        const errorData = await response.json();
        alert("Error: " + (errorData.message || "Registration failed"));
      }

    }catch(err){
      console.error("Error:", err);
    alert("Something went wrong. Try again later in cach block.");
    }

    console.log("Register with:", name, email, password);
    // TODO: connect with ASP.NET Core API
  };

  return (
    <div className="register-page">
      <div className="register-card">
        {/* Logo + Title */}
        <div className="register-header">
          <div className="logo-box">A</div>
          <h2>Register</h2>
          <p>Create your AdvocatePro account</p>
        </div>

        {/* Form */}
        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label>Full Name</label>
            <input
              type="text"
              value={name}
              onChange={(e) => setName(e.target.value)}
              required
            />
          </div>

          <div className="form-group">
            <label>Email</label>
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
          </div>
          <div className="form-group">
            <label>Phon No</label>
            <input
              type="number"
              value={phonno}
              onChange={(e) => setPhon(e.target.value)}
              required
            />
          </div>

          <div className="form-group">
            <label>Password</label>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />
          </div>

          <div className="form-group">
            <label>Confirm Password</label>
            <input
              type="password"
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
              required
            />
          </div>

          <button type="submit" className="btn-primary">
            Sign Up
          </button>
        </form>

        {/* Links */}
        <div className="extra-links">
          <p>
            Already have an account? <a href="/login">Login</a>
          </p>
        </div>
      </div>
    </div>
  );
}
